import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { BrowserRouter as Router, Route, Link, Redirect, NavLink, HashRouter } from "react-router-dom";
class HeaderMob extends Component {
  constructor(props) {
    super(props);
    this.logout = this.logout.bind(this);
  }
  logout()
  {
    localStorage.setItem('userLogin','');
    localStorage.clear(); 
    <Redirect to={'/login'} />
    window.parent.location = window.parent.location.href;
  }
  goBack() {
    window.history.back();
}
 render() {
  return (
    <div class="title_main">
      <div class="mob-angle hidden-md pull-left"><i class="fal fa-angle-left" onClick={()=> this.goBack()}></i></div>
      <span>{this.props.page_name}</span>
    </div>
  )
 }
}

export default HeaderMob;


// WEBPACK FOOTER //
// ./src/HeaderMob.js